<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="''"
      :btnClass="'btn-primary'"
      :btnToLink="false"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <div
      class="w100"
      v-if="
        typeof member_list === 'object' && Object.keys(member_list).length > 0
      "
    >
      <table class="table mb-4">
        <thead>
          <tr>
            <th>ライセンスNo</th>
            <th>氏名</th>
            <th>写真1</th>
            <th>写真2</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in member_list" :key="list.id">
            <td style="width: 20%">{{ list.license_no }}</td>
            <td style="width: 20%">{{ list.name_label }}</td>
            <td style="width: 30%">
              <img
                v-if="list.photo_1_url"
                :src="list.photo_1_url"
                class="member-photo w-100"
                @click="$emit('open-image-modal', list.photo_1_url)"
              />
            </td>
            <td style="width: 30%">
              <img
                v-if="list.photo_2_url"
                :src="list.photo_2_url"
                class="member-photo w-100"
                @click="$emit('open-image-modal', list.photo_2_url)"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-8">
          <bs-page-nav
            :pager_key="'member_photo_chk'"
            @to_click_event="pageAction"
          ></bs-page-nav>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>
<style>
.btn_order {
  text-decoration: none;
  cursor: pointer;
}
</style>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
import Common from '../../../common/common'
// import BsButton from '../../atoms/BsButton.vue'
// import BsSelect from '../../atoms/BsSelect.vue'
import BsPageNav from '../../molecules/BsPageNav.vue'
import config from '../../../const'
// import moment from 'moment'

export default {
  name: 'MemberListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '会員データ一覧',
      fromParentBtn: 'データ登録',
      member_obj: [],
      member_assets_obj: [],
      search_license_no: '',
      search_member_obj: {},
      sprm: {
        ids: [
          1311, 13851, 13871, 13919, 13925, 1293, 1319, 1398, 9856, 7967, 19,
          9665, 1925, 3852, 1341, 110, 4907, 1984, 1833, 5945, 3198, 1767, 2116,
          2325, 5045, 818, 2370, 204, 1095, 3742, 2119, 1623, 1280, 6498, 396,
          45, 7616, 2191, 778, 1315, 5528, 6179, 142, 11504, 162, 2088, 76,
          6765, 409, 1527, 1149, 15, 12421, 3086, 32, 4503, 3834, 190, 989, 258,
          10187, 1139, 1158, 662, 6644, 12278, 1732, 1553, 364, 12839, 13604,
          552, 5767, 373, 800, 567, 763, 8106, 1397, 3050, 92, 637, 3699, 7008,
          1731, 266, 6057, 5530, 973, 12346, 3134, 340, 1165, 2294, 2249, 3641,
          6558, 129, 3433, 367, 318, 773, 2189, 405, 407, 9867, 2978, 12259,
          5585, 5588, 6383, 4175, 960, 5779, 7876, 12523, 459, 714, 1364, 8872,
          5320, 2019, 1213, 14049, 5487, 3573, 2969, 3652, 5663, 2388, 7859,
          3127, 186, 1242, 2038, 2642, 1565, 550, 13942, 585, 3829, 9588, 3930,
          10271, 842, 624, 8902, 2948, 3545, 2029, 1365, 1442, 8066, 3660, 1042,
          3223, 4807, 6767, 68, 150, 3877, 663, 1821, 4839, 6160, 3883, 12062,
          1989, 2214, 1339, 4645, 5766, 4510, 5511, 2208, 2170, 14084, 2091,
          2161, 1083, 4629, 2363, 2944, 8576, 5942, 1622, 2133, 34, 8196, 1150,
          1779, 1841, 7793, 2696, 3919, 4626, 3477, 6502, 2962, 1058, 4522,
          7105, 3934, 9124, 1633, 1617, 358, 643, 692, 2148, 249, 3556, 5920,
          730, 3199, 1911, 11498, 926, 6797, 13038, 9769, 6275, 1168, 1475,
          3430, 3187, 6532, 4116, 3684, 257, 1041, 5722, 13231, 1812, 5613,
          3791, 1489, 1495, 9890, 8029, 5515, 472, 401, 14104, 7562, 9365, 503,
          823, 3045, 3059, 1236, 1172, 12723, 1818, 2410, 555, 1151, 1935, 3631,
          12524, 3321, 12570, 5206, 8715, 4500, 4489, 7040, 4119, 5399, 12,
          2966, 49, 755, 5697, 939, 1324, 680, 3237, 3220, 1517, 2669, 11689,
          902, 7738, 1227, 5401, 270, 9041, 9513, 6500, 1126, 5780, 4814, 3965,
          1068, 2401, 3438, 14011, 7754, 4251, 3500, 3266, 1838, 1363, 1607,
          419, 7446, 7747, 2531, 3550, 1399, 1594, 5139, 11512, 6586, 5332,
          9486, 7804, 8742, 7853, 4169, 9269, 9274, 9281, 9270, 4073, 9808,
          2028, 4297, 4655, 13137, 11447, 13735, 9248, 9390, 12904, 7751, 6463,
          6677, 12683, 6851, 12262, 74, 8513, 8515, 10469, 12352, 6044, 8939,
          5087, 6041, 10165, 5504, 13697, 6945, 1136, 14477, 4982, 11494, 3972,
          5943, 600
        ]
      },
      page: 0,
      page_limit: 100,
      page_sort: 'ASC',
      page_order: 'mfj_member_data.license_no',
      target_name: '',
      term_year_obj: [],
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    // BsButton,
    BsMsgAlert,
    // BsSelect,
    BsPageNav
  },
  computed: {
    get_term_year: function () {
      return typeof this.term_year_obj === 'object' &&
        typeof this.term_year_obj[0] === 'object' &&
        this.term_year_obj[0]['label']
        ? parseInt(this.term_year_obj[0]['label'])
        : parseInt(Common.getNowYear())
    },
    ...mapState({}),
    member_assets_list: function () {
      const lists = [...this.member_assets_obj]
      return function (m_id) {
        return lists
          .filter(asset => asset.m_id == m_id && asset.type == 100)
          .sort((a, b) => {
            if (parseInt(a.id) < parseInt(b.id)) {
              return -1
            } else {
              return 1
            }
          })
      }
    },
    member_list: function () {
      const lists = [...this.member_obj]
      lists.map(list => {
        list['photo_1_url'] = this.member_assets_list(list.id)[0]
          ? this.member_assets_list(list.id)[0].path
          : ''
        list['photo_2_url'] = this.member_assets_list(list.id)[1]
          ? this.member_assets_list(list.id)[1].path
          : ''
        return list
      })
      return lists
    }
  },

  async created() {
    await this.loadTermYear()
    await this.loadSearchParam()
    await this.loadMemberList(false)
    await this.loadMemberAssetsList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '会員データ一覧です。'
  },

  methods: {
    async loadSearchParam() {
      const params = { ...this.$store.getters.getSearchParam('member') }
      if (params) {
        Object.keys(params).forEach(key => {
          if (this.is_json(params[key])) {
            params[key] = JSON.parse(params[key])
          }
          this.sprm[key] = params[key]
        })
      }
    },

    async search_member() {
      this.isLoading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        this.page = 0
        await this.loadMemberList(false)
      } finally {
        this.isLoading = false
      }
    },
    async loadMemberList(flg) {
      const params = {}
      params['stat'] = [1]
      params['ids'] = this.sprm.ids

      let post_url = config.BASE_API_URL

      post_url += '/member/lists'
      if (typeof this.sprm === 'object') {
        Object.keys(this.sprm).forEach(sprm_key_param => {
          const sprm_key =
            sprm_key_param == 'license_cd'
              ? 'sp_' + sprm_key_param
              : sprm_key_param
          if (this.sprm[sprm_key] != '') {
            params[sprm_key] = this.sprm[sprm_key_param]
          }
        })
      }
      params['search_mode'] = 'list'
      params['pagelimit'] = this.page_limit
      if (this.page >= 0) params['p'] = this.page
      // params['pagegroup'] = 'mfj_member_data.id'
      params['pageorder'] = this.page_order
      params['pagesort'] = this.page_sort
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'member_photo_chk'
      })
      console.log('loadMemberList flg', flg)
      console.log('loadMemberList sprm', this.sprm)
      console.log('loadMemberList params', params)

      await this.basicPosts_S(post_url, params)
        .then(async response => {
          if (flg == 'csv') {
            console.log('loadMemberList download response', response)
            window.open(
              config.BASE_API_URL +
                '/member/download?file=' +
                response.data.body,
              '_blank'
            )
          } else if (flg !== false) {
            console.log('loadMemberList response', response)
            const tmp_obj =
              response.data && response.data.body && response.data.body[0]
                ? response.data.body[0]
                : {}
            let name_label = ''
            console.log('loadMemberList response tmp_obj', tmp_obj)
            if (typeof tmp_obj.name_1 === 'string') name_label += tmp_obj.name_1
            if (typeof tmp_obj.name_2 === 'string') name_label += tmp_obj.name_2
            if (typeof tmp_obj.name_3 === 'string') name_label += tmp_obj.name_3
            tmp_obj.name_label = name_label
            console.log('loadMemberList response tmp_obj', tmp_obj)
            this.search_member_obj = tmp_obj
          } else {
            console.log('loadMemberList response', response)
            this.member_obj =
              response.data && response.data.body ? response.data.body : []
            this.$store.dispatch('setSearchParam', {
              data: params,
              target: 'member_photo_chk'
            })
            const setPageData = {}
            setPageData.data =
              response.data && response.data.pager ? response.data.pager : {}
            setPageData.target = 'member_photo_chk'
            this.$store.dispatch('setPager', setPageData)
          }
        })
        .catch(async err => {
          console.log(err)
          if (!flg) this.member_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadMemberAssetsList() {
      const params = {}
      params['stat'] = [1]
      params['m_ids'] = this.sprm.ids
      params['type'] = 100
      await this.basicPosts_S(
        config.BASE_API_URL + '/member_assets/lists',
        params
      )
        .then(async response => {
          console.log('loadMemberAssetsList response', response)
          this.member_assets_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.member_assets_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    clear() {
      const params = { ...this.sprm }
      if (typeof params === 'object') {
        Object.keys(params).forEach(sprm_key => {
          params[sprm_key] = ''
        })
      }
      this.sprm = params
      this.attach_license_event_cd = []
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'member_photo_chk'
      })
    },
    async pageAction(page) {
      this.page = page
      await this.loadMemberList(false)
    },

    async loadTermYear() {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/term_year/lists', params)
        .then(async response => {
          console.log('loadTermYear response', response)
          this.term_year_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.term_year_obj = []
        })
        .finally(async () => {
          // this.sprm.last_sports_year = this.get_term_year
          //   ? this.get_term_year
          //   : ''
          this.$forceUpdate()
        })
    }
  },
  watch: {
    search_license_no: function (new_data, old_data) {
      if (new_data.length >= 6) {
        console.log(old_data)
        this.search_member_license_no()
      }
    },
    chk_watch_last_sports_year_higher: function (new_data, old_data) {
      // const param = { ...this.sprm }
      this.sprm.last_sports_year = ''
      if (
        parseInt(new_data) <= parseInt(this.sprm.last_sports_year_lower) ||
        this.sprm.last_sports_year_lower == ''
      ) {
        this.sprm.last_sports_year_higher = new_data
      } else {
        this.sprm.last_sports_year_higher = old_data
      }
      console.log('watch chk_watch_last_sports_year_higher', new_data, old_data)
    },
    chk_watch_last_sports_year_lower: function (new_data, old_data) {
      this.sprm.last_sports_year = ''
      if (
        parseInt(new_data) >= parseInt(this.sprm.last_sports_year_higher) ||
        this.sprm.last_sports_year_higher == ''
      ) {
        this.sprm.last_sports_year_lower = new_data
      } else {
        this.sprm.last_sports_year_lower = old_data
      }
      console.log('watch chk_watch_last_sports_year_lower', new_data, old_data)
    },
    chk_watch_last_sports_year: function (new_data, old_data) {
      this.sprm.last_sports_year_higher = ''
      this.sprm.last_sports_year_lower = ''
      console.log('watch chk_watch_last_sports_year', new_data, old_data)
    }
  }
}
</script>
